/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateAutoSalesInvoiceDto
 */
export interface GenerateAutoSalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof GenerateAutoSalesInvoiceDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateAutoSalesInvoiceDto
     */
    dateFrom: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateAutoSalesInvoiceDto
     */
    dateTo: string;
}

/**
 * Check if a given object implements the GenerateAutoSalesInvoiceDto interface.
 */
export function instanceOfGenerateAutoSalesInvoiceDto(value: object): value is GenerateAutoSalesInvoiceDto {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('dateFrom' in value) || value['dateFrom'] === undefined) return false;
    if (!('dateTo' in value) || value['dateTo'] === undefined) return false;
    return true;
}

export function GenerateAutoSalesInvoiceDtoFromJSON(json: any): GenerateAutoSalesInvoiceDto {
    return GenerateAutoSalesInvoiceDtoFromJSONTyped(json, false);
}

export function GenerateAutoSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateAutoSalesInvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'dateFrom': json['dateFrom'],
        'dateTo': json['dateTo'],
    };
}

export function GenerateAutoSalesInvoiceDtoToJSON(value?: GenerateAutoSalesInvoiceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'dateFrom': value['dateFrom'],
        'dateTo': value['dateTo'],
    };
}

